module.exports = __webpack_public_path__ + "Open_Sans-normal-400.ce659615885f33d928eb.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Open_Sans-normal-400.woff
// module id = 901
// module chunks = 2